import React from "react";
import Update from "modules/roles/components/Update";

const RolesUpdatePage = () => {
  return <Update />;
};

export default RolesUpdatePage;
